import React from 'react';
import './photoVideos.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const PhotoVideos = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="plans">
      <div className="general-background-image">
        <div className="back">
          <h2>{t('photosVideosPlan')}</h2>
          <Link className="link back-link" to="/">
            {t('home')}
          </Link>
        </div>
      </div>
      <div className="photo-plans container">
        <h2
          className="general-header found-header"
          style={{ marginTop: '100px' }}
        >
          Photo&Video package
        </h2>
        <table>
          <tr>
            <th>Band</th>
            <th>Details</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Buy</th>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>10</td>
            <td>200</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 11-20</td>
            <td>170</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 21-30</td>
            <td>150</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 31-40</td>
            <td>120</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 41-50</td>
            <td>100</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 51-100</td>
            <td>50</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>products</td>
            <td>Product photography</td>
            <td>from 100-..</td>
            <td>35</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>External photography</td>
            <td>Photography</td>
            <td>8h</td>
            <td>1500</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
          <tr>
            <td>External photography</td>
            <td>Video recording</td>
            <td>8h</td>
            <td>2000</td>
            <td>
              <button className="btn">Buy</button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default PhotoVideos;
